import {
    createRouter, createWebHistory, NavigationGuard
} from 'vue-router';
import { getBasePath } from '@agyletime/vue-3-common/src/plugins/basePath';
 
// Guards
import {
    SessionGuard,
    PageTitleSetter,
    FeatureFlowGuard,
    RoleGuard
} from '@agyletime/vue-3-common/src/routes/guard';
 
// Real production components
import { TeamAndSchedule as TeamAndSchedule } from '../components';
import { NavigationErrorGuard } from './guard';
 
// Config
const basePath = getBasePath();
// Commented out - kept for future ACL bypass logic if needed
// const _BYPASS_ACL = import.meta.env.VITE_BYPASS_ACL === 'true';
 
// Router initialization
export const router = createRouter({
    history: createWebHistory(basePath + '/'),
    routes: [
    // -------------------------------------
    // PRODUCTION ROUTES
    // -------------------------------------
        {
            path: '/',
            name: 'Home',
            component: TeamAndSchedule,
            meta: { title: 'Team Schedule' },
            beforeEnter: [
                FeatureFlowGuard('2025q4-pvdev-37-teamschedule-enhanced'),
                RoleGuard(['can_view_team_schedule'], true)
            ]
        },
 
        // -------------------------------------
        // EXAMPLE ROUTES (Dev / Internal)
        // Note: Example components removed - they don't exist in this project
        // -------------------------------------
        {
            path: '/team-schedule',
            name: 'Team Schedule',
            component: TeamAndSchedule,
            meta: { title: 'Team Schedule' },
            beforeEnter: [
                FeatureFlowGuard('2025q4-pvdev-37-teamschedule-enhanced'),
                RoleGuard(['can_view_team_schedule'], true)
            ]
        },
        // -------------------------------------
        // ⚙️ BUILD INFO PAGE
        // -------------------------------------
        {
            path: '/build',
            name: 'BuildInfo',
            meta: { title: 'Build Info' },
            component: {
                template: `
          <div>
            <h1>Build Info</h1>
            <dl class="build-info-list" style="width: 50vw; font-size: 1.2rem">
              <div v-for="[key, value] in Object.entries(buildInfo)" :key="key"
                   style="border-bottom: 1px dashed whitesmoke; display: flex; justify-content: space-between; margin-bottom: 1rem;">
                <dt style="font-weight: bold;">{{ key }}</dt>
                <dd>{{ value }}</dd>
              </div>
            </dl>
          </div>
        `,
                data() {
                    return { buildInfo: __BUILD_INFO__ };
                }
            }
        }
    ]
});
 
// -------------------------------------
// GLOBAL GUARDS
// -------------------------------------
router.beforeEach(SessionGuard);
router.beforeEach(PageTitleSetter as NavigationGuard);
router.afterEach(NavigationErrorGuard);
 
// TEMP DEV BYPASS - Remove before committing
// Invert condition to avoid empty block while keeping logic intact
/* if (!BYPASS_ACL) {
    // Add FeatureFlow + Role Guard to routes dynamically
    router.getRoutes().forEach((route) => {
        if ([ 'Home', 'Team Schedule' ].includes(route.name as string)) {
            route.beforeEnter = [
                FeatureFlowGuard('2025q4-pvdev-37-teamschedule-enhanced'),
                RoleGuard(['can_view_team_schedule'], true)
            ];
        }
    });
 
    // Navigation error guard
    import('./guard').then(({ NavigationErrorGuard }) => {
        router.afterEach(NavigationErrorGuard);
    });
}*/

export default router;